/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Faq_Q1Inputs */

const en_pc_online_faq_q1 = /** @type {(inputs: Pc_Online_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is PdfCraft Online free?`)
};

const zh_pc_online_faq_q1 = /** @type {(inputs: Pc_Online_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 在线版免费吗？`)
};

/**
* | output |
* | --- |
* | "Is PdfCraft Online free?" |
*
* @param {Pc_Online_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_faq_q1 = /** @type {((inputs?: Pc_Online_Faq_Q1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Faq_Q1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_faq_q1(inputs)
	return zh_pc_online_faq_q1(inputs)
});
export { pc_online_faq_q1 as "pc.online.faq.q1" }